<template>
	<v-dialog
		v-model="dialog"
		max-width="700px"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				:text="text"
				:color="text ? 'white' : 'secondary'"
				class="mr-2"
				@click.stop="dialog = true"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-2">mdi-magnify</v-icon>
				検索
			</v-btn>
		</template>
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">日報検索</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-card-text class="pa-2">
				<v-form ref="form" lazy-validation>
					<v-menu
						ref="menu"
						v-model="datePicker"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="datesText"
								label="日付"
								class="mt-4"
								required
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker
							class="date-picker"
							v-model="dates"
							no-title
							scrollable
							range
							locale="ja-JP"
							@change="changeDateRange"
						>
						</v-date-picker>
					</v-menu>
					<v-text-field v-model="q.title_cont" class="mt-4" label="件名" outlined dense />
					<v-select
						:items="users"
						item-text="full_name"
						item-value="id"
						v-model="q.user_id_eq"
						class="mt-4"
						label="日報作成者"
						clearable
						outlined
						dense
					/>
					<v-select
						:items="templates"
						item-text="name"
						item-value="id"
						v-model="q.daily_report_template_id_eq"
						class="mt-4"
						label="日報テンプレート名"
						clearable
						outlined
						dense
					/>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters>
					<v-col cols="0" sm="2"></v-col>
					<v-col cols="12" sm="8">
						<v-row class="ma-0 pa-0" justify="center">
							<v-btn class="ma-1" @click="searchReports" color="primary">
								<v-icon class="mr-2">mdi-magnify</v-icon>
								検索</v-btn>
							<v-btn class="ma-1" @click="resetForm" outlined color="primary"
								>
								<v-icon class="mr-2">mdi-autorenew</v-icon>
								クリア</v-btn
							>
						</v-row>
					</v-col>
					<v-col cols="0" sm="2">
						<v-row v-if="!$vuetify.breakpoint.xs" no-gutters justify="end">
							<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		text: {
			type: Boolean,
			required: false,
			default: false,
		},
		query: { type: Object, required: true, default: () => {} },
		open: {
			type: Boolean,
			required: true,
			default: false,
		},
		date_range: {
			type: Array,
			required: true,
			default: () => [],
		},
		users: {
			type: Array,
			required: true,
			default: [
				{
					id: {
						type: String,
						required: true,
						default: null,
					},
					full_name: {
						type: String,
						required: true,
						default: null,
					},
				},
			],
		},
		templates: {
			type: Array,
			required: true,
			default: [
				{
					id: {
						type: Number,
						required: true,
						default: null,
					},
					full_name: {
						type: String,
						required: true,
						default: null,
					},
				},
			],
		},
	},
	data() {
		return {
			datePicker: false,
			dates: [],
			dialog:false,
		}
	},
	methods: {
		searchReports() {
			this.dialog = false,
			this.$emit("search-reports")
		},
		resetForm() {
			this.$refs.form.reset()
		},
		changeDateRange() {
			this.dateRange = this.dates
		},
	},
	computed: {
		q: {
			get() {
				return this.query
			},
			set(newValue) {
				return this.$emit("update:query", newValue)
			},
		},
		dateRange: {
			get() {
				return this.date_range
			},
			set(newValue) {
				return this.$emit("update:date_range", newValue)
			},
		},
		datesText: {
			get() {
				return this.dates.length ? this.dates.join(" ~ ") : null
			},
			set(newValue) {
				return
			},
		},
	},
}
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
	margin-top: 0;
}
</style>